import { useEffect } from "react";
import {
    scheduleAbandonedGiftEmailsAPI,
    submitAbandonedGiftDataAPI,
    validateAbandonedGiftTokenAPI,
} from "@qgiv/donation-form";
import { log } from "@qgiv/core-js";

/**
 *
 * @param {object} props
 * @param {object} props.abandonedGiftData
 * @param {boolean} props.acceptedEmailReminders
 * @param {Function} props.closeModalDisplayType
 * @param {Function} props.dispatchSetAcceptEmailReminderDataFalse
 * @param {Function} props.dispatchSetHasScheduledReminderEmails
 * @param {object} props.emailData
 * @param {number} props.formId
 * @param {string} props.recipientEmail
 * @param {Function} props.sendEmailsScheduledPostMessage
 * @param {string} props.token
 * @returns {null}
 */
const SubmitAbandonedGiftData = ({
    abandonedGiftData,
    acceptedEmailReminders,
    closeModalDisplayType,
    dispatchSetAcceptEmailReminderDataFalse,
    dispatchSetHasScheduledReminderEmails,
    emailData,
    formId,
    recipientEmail,
    sendEmailsScheduledPostMessage,
    token,
}) => {
    useEffect(() => {
        /**
         * @async
         * @function submitAbandonedGiftData
         * @returns {Promise<void>}
         */
        const submitAbandonedGiftData = async () => {
            if (acceptedEmailReminders) {
                try {
                    const validateTokenResponse =
                        await validateAbandonedGiftTokenAPI({
                            formId,
                            recipientEmail,
                            token,
                        });
                    const validateTokenResponseData =
                        validateTokenResponse?.data || {};
                    const validatedToken = validateTokenResponseData?.token;
                    const emailDataWithToken = {
                        ...emailData,
                        token: validatedToken,
                    };
                    const submitAbandonedGiftDataResponse =
                        await submitAbandonedGiftDataAPI({
                            abandonedGiftData,
                            formId,
                            token: validatedToken,
                        });
                    const scheduleEmailsResponse =
                        await scheduleAbandonedGiftEmailsAPI(
                            emailDataWithToken,
                        );
                    dispatchSetAcceptEmailReminderDataFalse();
                    dispatchSetHasScheduledReminderEmails();
                    log({
                        submitAbandonedGiftDataResponse,
                        scheduleEmailsResponse,
                        validatedToken,
                    });
                    // give time for tracking api call to be started
                    setTimeout(() => {
                        sendEmailsScheduledPostMessage();
                        closeModalDisplayType();
                    }, 1000);
                } catch (error) {
                    log({ error });
                }
            }
        };
        submitAbandonedGiftData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};

export default SubmitAbandonedGiftData;
